import * as urlWebservice from "utils/apis"

export const uploadPaths = {
  profilePicture: (filename) =>
    `${urlWebservice.BASE_URL_PRODUCT_MANAGEMENT}/uploads/userPictures/${filename}`,
  companyLogo: (filename) => `${urlWebservice.BASE_URL_PRODUCT_MANAGEMENT}/uploads/companyLogos/${filename}`,
  productImage: (filename) =>
    `${urlWebservice.BASE_URL_PRODUCT_MANAGEMENT}/uploads/productImages/${filename}`,
  qrCode: (filename) => `${urlWebservice.BASE_URL_PRODUCT_MANAGEMENT}/uploads/qrcodes/${filename}`,
};
